import React, { useEffect, useState, useMemo } from 'react';
import { getImages } from '../const';

const PriceMismatchTable = ({
    priceMismatchData,
    appraisalData,
    numberFormatter,
    getDealershipSoldData,
    dealershipSold,
    isWholesale, getAppraisal,
    zipCodeData, currentPage,
    setCurrentPage, getVautoAppraisal,
    isTabView,
    handleMobPmtData
}) => {

    const [sortConfig, setSortConfig] = useState({ key: 'none', direction: 'ascending' });

    const [fetchingData, setFetchingData] = useState(false);

    const getPriceDiff = (vehicle) => {
        return vehicle.price - (appraisalData && vehicle.vin in appraisalData ? (isWholesale ? appraisalData[vehicle.vin].appraisal : appraisalData[vehicle.vin].avg_retail) : 0);
    }

    useEffect(() => {
        console.log("get appraisasls useeffect isWholesale");
        getCurrentAppraisals();

    }, [priceMismatchData, isWholesale]);

    const getCurrentAppraisals = async () => {

        setFetchingData(true);

        //const paginatedData = sortedData && sortedData.slice((currentPage - 1) * pageSize, currentPage * pageSize);

        const newPaginatedData = await Promise.all(paginatedData.map(async (v, i) => {

            if (appraisalData && v.vin in appraisalData) {

                //change me
                if (appraisalData[v.vin].appraisal == 0) {
                    const appraisal_data = await getAppraisal(v);
                    appraisalData[v.vin].appraisal = appraisal_data.appraisal;
                    appraisalData[v.vin].avg_retail = appraisal_data.avg_retail;
                }

                return appraisalData[v.vin];
            } else
                return {};
        }));

        console.log(newPaginatedData);

        setFetchingData(false);
    }

    const openVautoAppraisal = async (vin, mileage) => {
        const data = await getVautoAppraisal({ 'vin': vin, 'mileage': mileage });

        if (data.success && data.deeplink) window.open(data.deeplink, "_blank", "noreferrer");
    }

    //const [sortedData, setSortedData] = useState([...priceMismatchData]);

    const sortedData = useMemo(() => {
        console.log("sorteddata useMemo");
        let sortableData = [...priceMismatchData];
        if (sortConfig !== null) {
            sortableData.sort((a, b) => {
                const a_appraisal = appraisalData && a.vin in appraisalData ? appraisalData[a.vin] : { 'appraisal': 0, 'avg_retail': 0 };
                const b_appraisal = appraisalData && b.vin in appraisalData ? appraisalData[b.vin] : { 'appraisal': 0, 'avg_retail': 0 };

                if ((sortConfig.key == 'appraisal' || sortConfig.key == 'avg_retail' || sortConfig.key == 'difference') && (a_appraisal.appraisal == 0 || b_appraisal.appraisal == 0)) return 0;

                if (sortConfig.key == 'difference') {

                    a[sortConfig.key] = getPriceDiff(a);
                    b[sortConfig.key] = getPriceDiff(b);
                }

                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
        }

        return sortableData;
    }, [priceMismatchData, sortConfig]);

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };
    const [expandedRow, setExpandedRow] = useState(null);
    const toggleRow = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };
    // 
    const [isEditable, setIsEditable] = useState(false);
    const toggleEdit = () => {
        setIsEditable(prev => !prev);
    };

    // Custom Pagination 
    const pageSize = 20;

    const totalPages = Math.ceil(sortedData.length / pageSize);
    //const [paginatedData,setPaginatedData] = useState(sortedData && sortedData.slice((currentPage - 1) * pageSize, currentPage * pageSize));

    const paginatedData = useMemo(() => {
        console.log("pagenateddata useMemo");
        return sortedData && sortedData.slice((currentPage - 1) * pageSize, currentPage * pageSize);
    }, [currentPage, sortedData]);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const renderPagination = () => {
        const pageNumbers = [];

        if (totalPages <= 6) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            pageNumbers.push(1, 2);

            if (currentPage > 3) {
                pageNumbers.push('...');
            }

            if (currentPage > 2 && currentPage < totalPages - 1) {
                pageNumbers.push(currentPage);
            }
            if (currentPage < totalPages - 2) {
                pageNumbers.push('...');
            }
            pageNumbers.push(totalPages - 1, totalPages);
        }
        return pageNumbers.map((page, index) => (
            <li
                key={index}
                className={`page-item ${page === currentPage ? 'active' : ''} ${page === '...' ? 'disabled' : ''}`}
            >
                {page === '...' ? (
                    <span className="page-link">...</span>
                ) : (
                    <button
                        type='button'
                        className="page-link"
                        onClick={() => handlePageChange(page)}
                    >
                        {page}
                    </button>
                )}
            </li>
        ));
    };

    const [dealershipLoading, setDealershipLoading] = useState(false);

    const handleMouseEnter = (dealership) => {
        setDealershipLoading(true);
        getDealershipSoldData({ dealership }).finally(() => {
            setDealershipLoading(false);
        });
    };


    return (
        <>
            {/* {console.log("paginatedData", paginatedData)} */}
            <div className='custom-table price-mismatch-table'>
                <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                    {!isTabView &&
                        <thead>
                            <tr>
                                <th style={{ width: '30%' }}
                                    className={
                                        sortConfig.key === 'title'
                                            ? sortConfig.direction === 'ascending'
                                                ? 'text-start ps-4 sort-asc'
                                                : 'text-start ps-4 sort-desc'
                                            : 'text-start ps-4'
                                    }
                                    onClick={() => requestSort('title')}>
                                    Vehicle Info
                                    <span className='sort-icon pm-sort-icon ms-3'></span>
                                </th>
                                <th style={{ width: '8%' }}
                                    className={
                                        sortConfig.key === 'price'
                                            ? sortConfig.direction === 'ascending'
                                                ? 'sort-asc'
                                                : 'sort-desc'
                                            : ''
                                    }
                                    onClick={() => requestSort('price')}>
                                    List Price
                                    <span className='sort-icon pm-sort-icon ms-3'></span>
                                </th>
                                <th style={{ width: '16%' }}
                                    className={
                                        sortConfig.key === (isWholesale ? 'appraisal' : 'avg_retail')
                                            ? sortConfig.direction === 'ascending'
                                                ? 'sort-asc'
                                                : 'sort-desc'
                                            : ''
                                    }
                                    onClick={() => requestSort(isWholesale ? 'appraisal' : 'avg_retail')}>
                                    {isWholesale ? (
                                        <>
                                            Wholesale <br />Price
                                        </>
                                    ) : (
                                        <>
                                            Avg Retail <br />Price
                                        </>
                                    )}
                                    <span className='sort-icon pm-sort-icon ms-3'></span>
                                </th>
                                <th style={{ width: '11%' }}
                                    className={
                                        sortConfig.key === 'difference'
                                            ? sortConfig.direction === 'ascending'
                                                ? 'sort-asc'
                                                : 'sort-desc'
                                            : 'text-start'
                                    }
                                    onClick={() => requestSort('difference')}>
                                    Difference
                                    <span className='sort-icon pm-sort-icon ms-3'></span>
                                </th>
                                <th style={{ width: '23%' }}
                                    className={
                                        sortConfig.key === 'dealership'
                                            ? sortConfig.direction === 'ascending'
                                                ? 'text-start sort-asc'
                                                : 'text-start sort-desc'
                                            : 'text-start'
                                    }
                                    onClick={() => requestSort('dealership')}>
                                    Dealership
                                    <span className='sort-icon pm-sort-icon ms-3'></span>
                                </th>
                                <th style={{ width: '6%' }}>VDP Link</th>
                                <th style={{ width: '6%' }}>vAuto</th>
                            </tr>
                        </thead>
                    }
                    <tbody>
                        {paginatedData.map((item, index) => {
                            const priceDiff = getPriceDiff(item);

                            return (
                                <tr key={index} className={`${expandedRow === index && 'active'}`}>
                                    <td className='text-start'>
                                        <div className='d-flex align-items-center pmt-flex'>
                                            {!isTabView &&
                                                <div className='pmt-img'>
                                                    <img
                                                        src={item?.image}
                                                        alt="site icon"
                                                        onError={(e) => {
                                                            e.target.src = getImages("unavailable_stockphoto.avif")
                                                        }}
                                                    />
                                                </div>
                                            }
                                            <div className='pmt-content ps-lg-3'>
                                                <div className='sm-title fw-600 mb-lg-2 mob-text-red'>{item.title}</div>
                                                {!isTabView &&
                                                    <div className='xs-title ocrastd mb-1 pm-vin-number'>{item.vin}</div>
                                                }
                                                <div className='d-lg-flex align-items-center justify-content-between'>
                                                    <div className='xsm-title pe-xxl-4 order-2 my-1 my-lg-0'><span className='fw-700 text-white'>{item.dom_is}</span> DOL</div>
                                                    <div className='xsm-title mob-font-12'>{item.mileage?.toLocaleString()} miles</div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    {!isTabView && (
                                        <>
                                            <td className='font-1-32em fw-600 avenir'>
                                                {numberFormatter(item.price, true)}
                                            </td>
                                            <td className='font-1-32em fw-600 avenir text-nowrap'>
                                                {appraisalData && item.vin in appraisalData && appraisalData[item.vin].appraisal && appraisalData[item.vin].avg_retail ?
                                                    (numberFormatter(isWholesale ? appraisalData[item.vin].appraisal : appraisalData[item.vin].avg_retail, true)) : (
                                                        fetchingData ?
                                                            <div className="float-points">
                                                                <div className="dot-collision"></div>
                                                            </div>
                                                            :
                                                            "-"
                                                    )}
                                            </td>
                                            <td className={`font-1-32em fw-600 avenir text-green text-start ${priceDiff <= 0 ? 'text-green' : 'text-red'}`}>
                                                {appraisalData && item.vin in appraisalData && appraisalData[item.vin].appraisal && appraisalData[item.vin].avg_retail ?
                                                    <>
                                                        <img className='me-1' src={getImages(priceDiff <= 0 ? 'arrow-green-down.png' : 'arrow-red-down.png')} /> {numberFormatter(priceDiff, true)}
                                                    </>
                                                    :
                                                    (
                                                        fetchingData ?
                                                            <div className="float-points">
                                                                <div className="dot-collision"></div>
                                                            </div>
                                                            :
                                                            "-"
                                                    )
                                                }
                                            </td>
                                        </>
                                    )}
                                    <td className='text-lg-start text-end fw-500 font-1em'>
                                        <div className='dealer-col-flex'>
                                            <div className="position-relative d-inline-block">
                                                <a className='pmt-label text-ellips' href={'/dealer-analysis?dealership=' + encodeURIComponent(item.dealership)} target="_blank">
                                                    <span className='pmt-label'>{item.dealership}</span>
                                                </a>
                                            </div>
                                            <div className='xsm-title text-lred fw-500 mb-lg-1'>{item.location}</div>
                                            {isTabView && (
                                                <>
                                                    {/* {zipCodeData && item.zip_is in zipCodeData && <div className='xsm-title'><img src={getImages('icon-pin.png')} />
                                                        <span className='fw-700 text-white ps-1''>{numberFormatter(zipCodeData[item.zip_is].distance)}</span> miles away
                                                    </div>} */}
                                                    <div className='xsm-title'>
                                                        <img src={getImages('icon-pin.png')} />
                                                        <span className='fw-700 text-white ps-1'>50</span> miles away
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </td>
                                    {!isTabView && (
                                        <>
                                            <td>
                                                {item.vdp_url ? <a href={item.vdp_url} className='red-transparent-btn md-btn text-uppercase w-130 d-inline-block' target="_blank">View</a> : <span></span>}
                                            </td>
                                            <td>
                                                <a onClick={() => openVautoAppraisal(item.vin, item.mileage)} className='red-transparent-btn md-btn text-uppercase w-130 d-inline-block'>Appraise</a>
                                            </td>
                                        </>
                                    )}
                                    {isTabView && (
                                        <>
                                            <td>
                                                <button type='button' className='aia-ac-arrow mob-aia-pm-btn' onClick={()=>handleMobPmtData(item)}>
                                                    <img src={getImages('arrow-closed.svg')} alt='Arrow' />
                                                </button>
                                            </td>
                                        </>
                                    )}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <div className='mt-5 text-center custom-pagination'>
                <nav aria-label="Page navigation example" className='d-inline-block'>
                    <ul className="pagination">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <button className="page-link back-btn me-5" type="button" onClick={handlePreviousPage}>Back</button>
                        </li>
                        {renderPagination()}
                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link next-btn ms-5" type="button" onClick={handleNextPage}>Next</button>
                        </li>
                    </ul>
                </nav>
            </div>
        </>
    );
};

export default PriceMismatchTable;
